export default function RichTextView({ data }) {
  const html = data?.content_html || "";
  return (
    <div className="w-full max-w-2xl mx-auto" data-testid="embed-content-wrapper">
      {data?.title ? (
        <h2 className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-zinc-950 mb-5">
          {data.title}
        </h2>
      ) : null}
      <div
        className="prose-rt text-[15px] leading-relaxed text-zinc-800"
        data-testid="richtext-view-body"
        // Rendered content is sanitized server-side before storage.
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}
